var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 293,
    viewBox: "0 0 348 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 70,
    width: 162,
    height: 129,
    rx: 4.86743,
    stroke: "#B6B3B3",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 86,
    width: 199,
    height: 129,
    rx: 5.86743,
    fill: "#ECECF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 149,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 226.5,
    y: 149,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 111,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 188,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#10A37F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 188,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6AFBF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 189.5,
    y: 188,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6AFBF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: 137.5,
    x2: 258.5,
    y2: 137.5,
    stroke: "#D9D9D9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: 169.5,
    x2: 258.5,
    y2: 169.5,
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.324 119.824L256.821 124.321M252.324 119.824C249.088 123.06 243.842 123.06 240.606 119.824C237.37 116.588 237.37 111.342 240.606 108.106C243.842 104.87 249.088 104.87 252.324 108.106C255.56 111.342 255.56 116.588 252.324 119.824Z",
    stroke: "#6E6E80",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2716_26409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.053 173.371C269.099 173.422 270.131 173.523 271.147 173.673L271.002 174.661C272.003 174.808 272.988 175.004 273.955 175.245L274.197 174.276C275.208 174.529 276.2 174.831 277.17 175.178L276.834 176.117C277.783 176.457 278.712 176.843 279.615 177.271L280.042 176.368C280.981 176.813 281.896 177.303 282.782 177.835L282.267 178.691C283.129 179.209 283.965 179.768 284.769 180.365L285.364 179.563C286.197 180.182 286.998 180.84 287.765 181.536H287.766L287.094 182.276C287.838 182.951 288.549 183.662 289.223 184.405L289.963 183.733C290.659 184.5 291.317 185.302 291.935 186.135L291.134 186.731C291.732 187.536 292.291 188.37 292.809 189.232L293.665 188.718C294.197 189.604 294.686 190.518 295.131 191.457L294.23 191.886C294.658 192.789 295.043 193.716 295.382 194.665L296.322 194.328C296.669 195.299 296.97 196.291 297.222 197.303L296.254 197.545C296.496 198.512 296.691 199.496 296.838 200.497L297.827 200.352C297.976 201.368 298.077 202.4 298.127 203.445L297.13 203.493C297.154 203.992 297.167 204.495 297.167 205C297.166 205.505 297.154 206.007 297.13 206.506L298.127 206.553C298.077 207.598 297.976 208.63 297.827 209.646L296.838 209.502C296.691 210.503 296.496 211.488 296.254 212.454L297.222 212.696C296.97 213.708 296.669 214.7 296.322 215.67L295.382 215.334C295.043 216.283 294.658 217.211 294.23 218.114L295.131 218.541C294.686 219.481 294.196 220.394 293.664 221.28L292.809 220.767C292.291 221.629 291.732 222.464 291.134 223.269L291.935 223.863C291.317 224.696 290.659 225.498 289.963 226.265L289.223 225.594C288.549 226.338 287.838 227.048 287.094 227.723L287.765 228.463C286.998 229.158 286.196 229.816 285.364 230.435L284.769 229.634C283.965 230.231 283.129 230.791 282.267 231.309L282.781 232.163C281.895 232.695 280.981 233.186 280.042 233.631L279.615 232.729C278.712 233.157 277.783 233.542 276.834 233.882L277.17 234.821C276.2 235.168 275.208 235.469 274.197 235.722L273.955 234.754C272.988 234.995 272.003 235.191 271.002 235.338L271.147 236.326C270.131 236.476 269.099 236.576 268.053 236.627L268.006 235.63C267.508 235.654 267.005 235.666 266.5 235.666C265.995 235.666 265.493 235.654 264.994 235.63L264.946 236.627C263.9 236.576 262.868 236.476 261.852 236.326L261.998 235.338C260.997 235.191 260.012 234.995 259.045 234.754L258.803 235.722C257.792 235.469 256.799 235.169 255.829 234.821L256.166 233.882C255.217 233.542 254.289 233.157 253.386 232.729L252.958 233.631C252.018 233.186 251.104 232.696 250.218 232.164L250.733 231.309C249.871 230.791 249.036 230.231 248.232 229.634L247.635 230.435C246.803 229.816 246.001 229.158 245.234 228.463L245.906 227.723C245.162 227.048 244.451 226.337 243.777 225.594L243.037 226.265C242.341 225.498 241.683 224.696 241.064 223.863L241.866 223.269C241.268 222.464 240.71 221.629 240.192 220.767L239.335 221.281C238.803 220.395 238.314 219.481 237.869 218.541L238.771 218.114C238.343 217.211 237.957 216.283 237.618 215.334L236.678 215.67C236.331 214.7 236.029 213.708 235.777 212.696L236.746 212.454C236.504 211.488 236.309 210.503 236.162 209.502L235.173 209.646C235.024 208.63 234.922 207.598 234.872 206.553L235.87 206.506C235.858 206.256 235.848 206.006 235.842 205.755L235.833 205C235.833 204.495 235.846 203.992 235.87 203.493L234.872 203.445C234.922 202.4 235.024 201.368 235.173 200.352L236.162 200.497C236.309 199.496 236.504 198.511 236.746 197.545L235.777 197.303C236.029 196.291 236.331 195.299 236.678 194.328L237.618 194.665C237.957 193.716 238.343 192.789 238.771 191.886L237.869 191.458C238.314 190.518 238.802 189.604 239.334 188.718L240.192 189.232C240.71 188.37 241.268 187.536 241.866 186.731L241.064 186.135C241.683 185.302 242.341 184.5 243.037 183.733L243.777 184.405C244.451 183.662 245.162 182.951 245.906 182.276L245.234 181.536C246.001 180.84 246.802 180.182 247.635 179.563L248.232 180.365C249.036 179.768 249.871 179.209 250.733 178.691L250.218 177.834C251.104 177.302 252.019 176.813 252.958 176.368L253.386 177.271C254.289 176.843 255.217 176.457 256.166 176.117L255.829 175.178C256.799 174.83 257.791 174.529 258.803 174.276L259.045 175.245C260.012 175.004 260.997 174.808 261.998 174.661L261.852 173.673C262.868 173.523 263.9 173.422 264.946 173.371L264.994 174.369C265.493 174.345 265.995 174.333 266.5 174.333C267.005 174.333 267.508 174.345 268.006 174.369L268.053 173.371Z",
    fill: "#ECECF1",
    stroke: "#B6B3B3",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.195 194.694C256.743 194.146 257.487 193.837 258.263 193.837C259.039 193.837 259.784 194.145 260.332 194.694L267.122 201.483L273.91 194.695C274.459 194.146 275.203 193.837 275.979 193.837C276.755 193.837 277.499 194.146 278.048 194.695C278.597 195.243 278.905 195.987 278.905 196.763C278.905 197.539 278.597 198.284 278.048 198.832L271.259 205.621L278.048 212.41C278.597 212.958 278.905 213.703 278.905 214.479C278.905 215.255 278.597 215.999 278.048 216.547C277.499 217.096 276.755 217.405 275.979 217.405C275.203 217.405 274.459 217.096 273.91 216.547L267.122 209.759L260.332 216.548C259.784 217.097 259.039 217.405 258.263 217.405C257.487 217.405 256.743 217.097 256.195 216.548C255.646 215.999 255.337 215.255 255.337 214.479C255.337 213.703 255.646 212.959 256.195 212.41L262.984 205.621L256.195 198.832C255.646 198.283 255.337 197.539 255.337 196.763C255.337 195.987 255.646 195.243 256.195 194.694Z",
    fill: "#B6B3B3",
    stroke: "#ECECF1",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2716_26409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 88,
    fill: "white",
    transform: "translate(228.5 161)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.4d59aeaa7d6e5d5efc2df8112fe97ed4.svg";
export { ForwardRef as ReactComponent };